import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { previewBusinessReport } from '../api/businessReport';

// Nhắc TRƯỞNG PHÒNG (role TP có nhóm) nộp báo cáo doanh thu tuần.
// Hiện từ 16:30 Thứ 5 đến 17:00 Thứ 6 (giờ VN) NẾU nhóm của TP chưa nộp báo cáo tuần này.
// Bấm "Để sau" -> ẩn 1 giờ. "Gửi báo cáo"/"Mở biểu mẫu" -> mở màn Báo cáo kinh doanh.
const SNOOZE_MS = 60 * 60 * 1000; // ẩn 1 giờ khi bấm "Để sau"

// Giờ tường VN (UTC+7): đọc bằng getUTC* sau khi cộng offset.
const vnNow = () => new Date(Date.now() + 7 * 3600 * 1000);
function inReminderWindow(d = vnNow()) {
  const dow = d.getUTCDay(); // 0=CN … 4=T5 … 5=T6
  const mins = d.getUTCHours() * 60 + d.getUTCMinutes();
  if (dow === 4) return mins >= 16 * 60 + 30; // Thứ 5 từ 16:30
  if (dow === 5) return mins < 17 * 60; // Thứ 6 tới 17:00
  return false;
}

export default function WeeklyReportReminder({ onOpenReport }) {
  const { me } = useAuth();
  const [open, setOpen] = useState(false);
  const isSalesTP = !!me && me.role === 'TP' && !!me.group;
  const groupName = me?.group?.name || '';

  useEffect(() => {
    if (!isSalesTP) return;
    let alive = true;

    async function check() {
      if (!alive) return;
      // Cờ xem thử (QA): localStorage.ft_wr_force='1' -> hiện popup bất kỳ lúc nào (vẫn chỉ với TP).
      if (localStorage.getItem('ft_wr_force') === '1') { setOpen(true); return; }
      if (!inReminderWindow()) { setOpen(false); return; }
      const snoozeUntil = Number(localStorage.getItem('ft_wr_snooze') || 0);
      if (Date.now() < snoozeUntil) { setOpen(false); return; }
      try {
        const data = await previewBusinessReport();
        if (!alive) return;
        const g = (data.groups || []).find((x) => x.groupName === groupName);
        // Đã nộp (submitted) -> không nhắc nữa; chưa nộp -> hiện popup.
        setOpen(!(g && g.submitted));
      } catch {
        /* lỗi mạng -> thử lại lần poll sau */
      }
    }

    check();
    const iv = setInterval(check, 60 * 1000); // kiểm tra mỗi phút (bắt đúng mốc 16:30)
    return () => { alive = false; clearInterval(iv); };
  }, [isSalesTP, groupName]);

  if (!isSalesTP || !open) return null;

  const snooze = () => {
    localStorage.setItem('ft_wr_snooze', String(Date.now() + SNOOZE_MS));
    setOpen(false);
  };
  const openReport = () => {
    setOpen(false);
    if (onOpenReport) onOpenReport();
  };

  return (
    <div className="syncpop-bg">
      <div className="wrrem">
        <button className="wrrem-x" onClick={snooze} title="Đóng">×</button>
        <span className="wrrem-badge">🔔 Tự động nhắc</span>
        <div className="wrrem-ttl">Đến hạn nộp<br />báo cáo tuần</div>
        <div className="wrrem-msg">
          Anh/Chị Trưởng phòng vui lòng gửi báo cáo tuần đúng hạn để bộ phận tổng hợp hoàn tất báo cáo quản trị.
        </div>
        <div className="wrrem-info">
          <div className="wrrem-box">
            <div className="wrrem-ico">📅</div>
            <div>
              <div className="wrrem-cap">Hạn nộp:</div>
              <div className="wrrem-val">17:00 Thứ Sáu</div>
            </div>
          </div>
          <div className="wrrem-box">
            <div className="wrrem-ico">👥</div>
            <div>
              <div className="wrrem-cap">Người nhận:</div>
              <div className="wrrem-val">Ban điều hành</div>
            </div>
          </div>
        </div>
        <div className="wrrem-note">ⓘ Nếu đã nộp, vui lòng bỏ qua thông báo này.</div>
        <div className="wrrem-actions">
          <button className="wrrem-go" onClick={openReport}>✈️ Gửi báo cáo</button>
          <button className="wrrem-later" onClick={snooze}>🕒 Để sau</button>
          <button className="wrrem-open" onClick={openReport}>📄 Mở biểu mẫu</button>
        </div>
      </div>
    </div>
  );
}
